<template>
  <div class="home">
    <div class="bg-home top flex flex-col justify-between">
      <div class="mt-8"></div>
      <div class="bg-black relative text-white m-4 p-3 rounded-lg flex flex-row justify-between btn-my-credit"
           @click="goMyPage">
        <div>{{ $t('MyCredits') }}</div>
        <span>
          <span class="mr-2">{{ userInfo.tickets }}</span>
          <span class="icon-container float-right block">
            <img class="img-point inline-block mr-2" src="../assets/images/point.svg" alt="">
            <van-icon class="text-white" name="arrow"/>
          </span>
        </span>
      </div>
    </div>
    <div class="home-content h-full">
      <div class="p-4  text-white text-center">
        <div class="lucky-draw-banner mb-4" v-if="luckyDrawData && false" @click="$router.push('/lottery')">
          <div class="flex flex-row">
            <img v-if="luckyDrawData.logo" class="logo" :src="luckyDrawData.logo" alt="">
            <div class="lucky-draw-banner-right ml-4 text-left">
              <h3 class="text-hidden text-white-700">{{ $t('lottery_list.prize_' + luckyDrawType) }}{{ $t('lottery_list.prize', luckyDrawData) }}</h3>
              <p class="text-white-700 text-xs lh-14">
                <img class="w-3 inline-block img-date" src="../assets/images/lottery/date2.svg" alt="">
                {{ $t('lottery_list.sn', luckyDrawData) }} {{ formatDate(luckyDrawData.start_date, 'YYYY.MM.DD') }} -
                {{ formatDate(luckyDrawData.end_date, 'YYYY.MM.DD') }}
              </p>
              <van-button class="lucky-draw-button bg-main rounded-xl text-xs" type="warning">
                {{ $t('lottery_list.to_draw', luckyDrawData) }}
              </van-button>
            </div>
          </div>
        </div>
        <div class="headline flex flex-row justify-between" :class="$i18n.locale">
          <img class="img-line" src="../assets/images/line_left.png" alt="">
          <h1>{{ $t('home.header') }}</h1>
          <img class="img-line" src="../assets/images/line_right.png" alt="">
        </div>
        <p class="text-xs my-4 text-white-600 text-left">
          {{ $t('home.prompt') }}
        </p>
        <div class="machine-list bg-black p-4 rounded-lg">
          <h1 class="text-left mb-2 text-xs title-credit">{{ $t('home.self_exchange') }}</h1>
          <div class="divide-y divide-gray-700">
<!--            <div class="flex py-2">-->
<!--              <img class="machine-poster"-->
<!--                   src="../assets/images/beer.jpg">-->
<!--              <div class="ml-6 text-left flex-1">-->
<!--                <div class="flex flex-row justify-between">-->
<!--                  <h1 class="tracking-wide text-main font-bold">{{ $t('home.beer_machine') }}</h1>-->
<!--                  <img class="inline-block mb-2" src="../assets/images/map.svg" alt=""-->
<!--                       @click="openLocationDialog('beer')">-->
<!--                </div>-->
<!--                <p class="text-xs text-white-750 mt-2">{{ $t('home.beer_prompt') }}  </p>-->
<!--              </div>-->
<!--            </div>-->
            <div class="flex py-2">
              <img class="machine-poster"
                   src="../assets/poster.png">
              <div class="ml-6 text-left flex-1">
                <div class="flex flex-row justify-between">
                  <h1 class="tracking-wide text-main font-bold">{{ $t('home.prize_machine') }}</h1>
                  <img class="inline-block mb-2" src="../assets/images/map.svg" alt=""
                       @click="openLocationDialog('prize')">
                </div>
                <p class="text-xs text-white-750 mt-2 ">{{ $t('home.prize_prompt') }}  </p>
              </div>
            </div>
            <div class="flex py-2" >
              <img class="machine-poster"
                   src="../assets/images/cotton.png">
              <div class="ml-6 text-left flex-1">
                <div class="flex flex-row justify-between">
                  <h1 class="tracking-wide text-main font-bold">{{ $t('home.candy_machine') }}</h1>
                  <img class="inline-block mb-2" src="../assets/images/map.svg" alt=""
                       @click="openLocationDialog('candy')">
                </div>
                <p class="text-xs text-white-750 mt-2 ">{{ $t('home.candy_prompt') }}  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home-footer p-4">
<!--      <div v-if="isUseWechat" class="wechat-prompt">{{ $t('home.wechat_prize') }}</div>-->
      <van-button  class="w-full btn-scan bg-main rounded-lg text-base" type="warning" @click="onScan" :loading="loading">
        <img style="margin-top: 1px;"
             class="inline-block mr-2 mb-1" src="../assets/images/scan.svg" alt=""> {{ $t('home.scan') }}
      </van-button>
    </div>

    <van-dialog v-model="showDialogSelfHelp" :showConfirmButton="false" class="dialog-self-help p-6 bg-black text-white"
                title="">
      <div class="bg-images">
        <img class="img-location" src="../assets/images/location.png"/>
        <img class="rounded-md" src="../assets/images/bg-map.png"/>
      </div>
      <div class="mb-6" v-if="openType === 'beer'">
        <h1 class="my-4 text-lg">{{ $t('home.beer_machine') }}</h1>
        <div class="text-xs">
          <p class="py-4 text-center">{{ $t('home.beer_location_text') }}</p>
        </div>
      </div>
      <div class="mb-6" v-if="openType === 'prize'">
        <h1 class="my-4 text-lg">{{ $t('home.prize_machine') }}</h1>
        <div class="text-xs">
          <p class="py-4 text-center">{{ $t('home.prize_location_text') }}</p>
        </div>
      </div>
      <div class="mb-6" v-if="openType === 'candy'">
        <h1 class="my-4 text-lg">{{ $t('home.candy_machine') }}</h1>
        <div class="text-xs">
          <p class="py-4 text-center">{{ $t('home.location') }}</p>
        </div>
      </div>
      <img class="img-close" src="../assets/images/close.svg" @click="showDialogSelfHelp = false"/>
    </van-dialog>

    <van-dialog v-model="showDialogScan" class="dialog-scan p-6 bg-black text-white" title=""
                :showConfirmButton="false">
      <div v-if="step === 'ready_scan'">
        <div class="text-center" style="height: 100px">
          <p class="mb-2">Loading</p>
          <van-loading type="spinner"/>
        </div>
      </div>
      <div v-if="step === 'wait_exchange_beer'">
        <h1 class="text-xl text-center">{{ $t('home.beer') }}</h1>
        <h3 class="text-center mb-2">{{ beerData.value }}ml</h3>
        <img class="dialog-scan-logo" src="../assets/images/beer.jpg"/>
        <van-button class="w-full border-rounded-10 bg-main rounded-lg mt-4" type="warning" :loading="loading" @click="onExchangeBeer">
          {{ $t('home.exchange', {price: beerData.price}) }}
        </van-button>
      </div>
      <div v-if="step === 'wait_exchange_gift'">
        <h1 class="text-xl text-center">{{ $t('home.prize') }}</h1>
        <h3 class="text-center mb-2"></h3>
        <img class="dialog-scan-logo" src="../assets/poster.png"/>
        <van-button class="w-full border-rounded-10 bg-main rounded-lg mt-4" type="warning" :loading="loading" @click="onExchangeGift">
          {{ $t('home.exchange', {price: prizeData.price}) }}
        </van-button>
      </div>
      <div v-if="step === 'wait_exchange_candy'">
        <h1 class="text-xl text-center">{{ $t('home.candy') }}</h1>
        <h3 class="text-center mb-2"></h3>
        <img class="dialog-scan-logo" src="../assets/images/cotton.png"/>
        <van-button class="w-full border-rounded-10 bg-main rounded-lg mt-4" type="warning" :loading="loading" @click="onExchangeCandy">
          {{ $t('home.exchange', {price: candyData.price}) }}
        </van-button>
      </div>
      <div v-if="step === 'wait_exchange_yohi_beer'">
        <h1 class="text-xl text-center">{{ yohiBeerData.goodsName }}</h1>
        <h3 class="text-center mb-2"></h3>
        <img class="yohi-dialog-scan-logo" :src="yohiBeerData.goodsPic"/>
        <van-button class="w-full border-rounded-10 bg-main rounded-lg mt-4" type="warning" :loading="loading" @click="onExchangeYohiBeer">
          {{ $t('home.exchange', {price: yohiBeerData.goodsScore}) }}
        </van-button>
      </div>
      <div v-if="step === 'exchange_success'" class="text-center" style="height: 300px;">
        <img class="inline-block mb-2" src="../assets/images/completed.svg"/>
        <h1 class="text-xl">
          <div class="mb-2">{{ $t('home.exchange_success') }}</div>
          <div>
            <span v-if="exchangeType === 'beer'">{{ $t('home.exchange_beer_success') }}</span>
            <span v-else>{{ $t('home.exchange_goods_success') }}</span>
          </div>
        </h1>
        <p class="text-xs mt-4">
          <van-count-down :time="successCountSecond" :format="$t('home.count_down')" @finish="showDialogScan = false"/>
        </p>
      </div>
      <img class="img-close" src="../assets/images/close.svg" @click="showDialogScan = false"/>
    </van-dialog>
  </div>
</template>

<script>
import {isWechat, urlParameter, isJSONString, getNonceStr} from '@/helpers/utils'
import _ from 'lodash';
import {Toast, Dialog} from 'vant';
import querystring from 'querystring';

export default {
  name: 'Home',
  data() {
    return {
      readyQrScan: false,
      scanMock: true,
      scanResult: '',
      scanErrorResult: '',
      scanLoading: false,
      successCountSecond: null,
      step: 'ready_scan',
      userInfo: {
        tickets: 0,
      },
      showDialogSelfHelp: false,
      showDialogScan: false,
      beerData: {},
      prizeData: {},
      candyData: {},
      yohiBeerData: {},
      luckyDrawData: null,
      luckyDrawType: 'current',
      loading: false,
      openType: 'beer',
      exchangeType: 'beer',
      isUseWechat: false
    }
  },
  created() {
    this.isUseWechat = isWechat();
    this.$i18n.locale = localStorage.getItem('lang');
    this.initUrlParams();
    this.getUserCredit();
    this.initMessageWatcher();
  },
  mounted() {
    // Toast(this.$t('coming_soon'));
  },
  methods: {
    openLocationDialog(type = 'beer') {
      this.openType = type;
      this.showDialogSelfHelp = true;
    },
    initUrlParams() {
      // 判断是否是从礼品机地址返回的
      if (urlParameter('action') === 'pay_prize') {
        this.prizeData = {
          order_sn: urlParameter('order'),
          price: urlParameter('price'),
        };
        this.showDialogScan = true;
        this.step = 'wait_exchange_gift';
      }
      // 判断app扫码后跳转过来的
      const scanResult = urlParameter('scan_result');
      if (scanResult) {
        this.scanResult = scanResult;
        this.matchScanContentType();
      }
    },
    getScanResultFromUrl() {
      return location.search.split('scan_result=')[1];
    },
    getUserCredit() {
      const user_id = new URLSearchParams(window.location.search).get('user_id') || localStorage.getItem('user_id');
      localStorage.setItem('user_id', user_id);
      this.userInfo = JSON.parse(localStorage.getItem('userInfo') || JSON.stringify({tickets: 0}));
      this.setLuckyDrawData();
      // 拿token
      this.$http
          .post('user/signin_by_id', {user_id: user_id})
          .then((res) => {
            localStorage.setItem('Authorization', res.data.token);
            // 获取积分和中奖信息
            this.queryUserTickets(res.data.user);
            this.queryLuckDraw();
          });
    },
    queryUserTickets(user = {}) {
      this.$http.get('game/tickets/query')
          .then(result => {
            const userInfo = Object.assign(
                user,
                {tickets: result.data.tickets},
                {expire_item: result.data.expire_item}
            );
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            this.userInfo = userInfo;
          })
    },
    queryLuckDraw() {
      this.$http.get('game/lucky_draw/query')
          .then(result => {
            this.setLuckyDrawData(_.get(result, 'data'));
            localStorage.setItem('luckDraw', JSON.stringify(result.data));
          })
    },
    setLuckyDrawData(luckyDrawData) {
      if (!luckyDrawData) {
        luckyDrawData = JSON.parse(localStorage.getItem('luckDraw') || '{}');
      }
      this.luckyDrawData = _.get(luckyDrawData, 'current');
      if (!this.luckyDrawData) {
        this.luckyDrawData = _.get(luckyDrawData, 'next');
        this.luckyDrawType = 'next';
      }
      if (!this.luckyDrawData) {
        this.luckyDrawData = _.get(luckyDrawData, 'previous');
        this.luckyDrawType = 'previous';
      }
    },
    onScan() {
      /* eslint-disable */
      if (isWechat()) { // 微信扫码

        wx.miniProgram.redirectTo({
          url:'/pages/index/index?scan_code=1',        // 指定跳转至小程序页面扫码的路径
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.log(err);
          }
        });

        return true;
        this.loading = true;
        const timeStamp = parseInt(new Date().getTime() / 1000).toString();
        const nonceStr = getNonceStr();
        this.$http.post(`webpay/sign`, {
          url: encodeURIComponent(document.URL),
          timeStamp: timeStamp,
          nonceStr: nonceStr
        }).then(res => {
          wx.config({
            debug: process.env.NODE_ENV !== 'production',
            // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: process.env.VUE_APP_WX_APP_ID || 'wx685a757ba6c7974f', // 必填，公众号的唯一标识
            timestamp: timeStamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: res.data.sign, // 必填，签名
            jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
          });
          // 成功执行
          wx.ready(() => {
            this.loading = false;
            wx.scanQRCode({
              needResult: 1,
              scanType: ["qrCode", "barCode"],
              success: (result) => {
                this.scanResult = result.resultStr;
                this.matchScanContentType();
                console.log(result);// 扫码成功返回数据
              },
              fail: (err) => {
                Toast.fail(err);
                console.log('wx.scanQRCode fail', err) // 扫码失败
              }
            })
          });
          // 失败执行
          wx.error((res) => {
            this.loading = false;
            Toast.fail(res);
            console.log('wx.error', res);
          })
        }).catch(() => {
          this.loading = false;
        });
      } else {  // app扫码
        console.log('onScan');
        window.postMessage(JSON.stringify({action: 'scan'}), "*");
        try {
          window.CagesScanner.postMessage('action_scan');
        } catch(e) {}
      }
    },
    modifiedUrl(url) {
      const index = url.indexOf("?");
      if (index !== -1) {
        return url.slice(index + 1); // 去掉前缀部分
      } else {
        return url;
      }
    },
    matchScanContentType() {
      if (isJSONString(this.scanResult)) {
        this.scanResult = JSON.parse(this.scanResult);
      }
      if (this.scanResult) {
        if (this.isPrizeQrcode()) { // 礼品机
          if (isWechat()) {
            const scanResult = querystring.parse(this.modifiedUrl(this.scanResult));
            console.log(1111);

            console.log(scanResult);
            this.onPrizeExchange(scanResult)
            // Toast(this.$t('home.wechat_prize'), { duration: 3000 });
            // window.self.location.href = 'https://budweiser.cages.cn/?order=19108775169709067283&price=650&action=pay_prize#/';
          } else {
            window.self.location.href = this.scanResult;
          }
        } else if (this.isJsonQrcode()) {
          if (this.scanResult.type === 'candy') { // 棉花糖机
            this.candyData = this.scanResult;
            this.step = 'wait_exchange_candy';
            this.readyQrScan = false;
            this.showDialogScan = true;
          } else if (this.scanResult.type === 'beer_washer') { // 清洗啤酒机
            this.showDialogScan = false;
            Dialog.confirm({
              title: this.$t('home.beer_confirm_title'),
              message: this.$t('home.beer_confirm_message', { value: this.scanResult.value }),
              'confirm-button-text': this.$t('confirm'),
              'cancel-button-text': this.$t('cancel')
            }).then(() => {
              this.beerData = this.scanResult;
              this.onBeerWasher();
            }).catch(() => {});
          } else { // 啤酒机
            this.beerData = this.scanResult;
            this.step = 'wait_exchange_beer';
            this.readyQrScan = false;
            this.showDialogScan = true;
          }
        } else if (this.isTicketQrcode()) {
          const scanResult = querystring.parse(this.scanResult);
          if (scanResult.equipmentNo) { // 友海啤酒售货机
            this.yohiBeerData = scanResult;
            this.$http.post('game/tickets/yohi_info', this.yohiBeerData)
                .then(result => {
                  this.yohiBeerData.goodsPic = _.get(result, 'data.goodsPic');
                  this.step = 'wait_exchange_yohi_beer';
                  this.readyQrScan = false;
                  this.showDialogScan = true;
                }).catch(() => {
              this.step = 'wait_exchange_yohi_beer';
              this.readyQrScan = false;
              this.showDialogScan = true;
            });
          }
        } else {
          Toast.fail(this.$t('errors.qrcode'));
          this.showDialogScan = false;
        }
      } else {
        this.showDialogScan = false;
      }
    },
    isPrizeQrcode() {
      return typeof this.scanResult === 'string' && this.scanResult.startsWith('https://o.zhongdacloud')
    },
    isTicketQrcode() {
      return typeof this.scanResult === 'string' && this.scanResult.startsWith('https://c.cages.cn')
    },
    isJsonQrcode() {
      return this.scanResult.sn && this.scanResult.price && this.scanResult.value;
    },
    onPrizeExchange(scanResult) {
      // 礼品机代理
      this.loading = true;
      this.$http.post('game/tickets/zhongda', scanResult)
          .then((res) => {
            this.loading = false;
            if(res.data){
              window.self.location.href = res.data;
            }
          }).catch(() => {
        this.loading = false;
      });
    },
    onExchangeBeer() {
      // 啤酒兑换
      this.loading = true;
      this.$http.post('game/tickets/beer', this.beerData)
          .then(() => {
            this.loading = false;
            this.exchangeType = 'beer';
            this.exchangeCallback();
          }).catch(() => {
        this.loading = false;
      });
    },
    onBeerWasher() {
      // 啤酒机清洗
      this.loading = true;
      this.$http.post('game/tickets/beer_washer', this.beerData)
        .then(() => {
          this.loading = false;
          Toast.success(this.$t('home.wash_success'));
        }).catch(() => {
        this.loading = false;
      });
    },
    onExchangeGift() {
      // 礼品兑换
      this.loading = true;
      this.$http.post('game/tickets/prize', this.prizeData)
          .then(() => {
            this.loading = false;
            this.exchangeType = 'gift';
            this.exchangeCallback();
          }).catch(() => {
        this.loading = false;
      });
    },
    onExchangeCandy () {
      // 棉花糖兑换
      this.loading = true;
      this.$http.post('game/tickets/candy', this.candyData)
        .then(() => {
          this.loading = false;
          this.exchangeType = 'candy';
          this.exchangeCallback();
        }).catch(() => {
        this.loading = false;
      });
    },
    onExchangeYohiBeer() {
      this.loading = true;
      this.$http.post('game/tickets/yohi_beer', {
        equipmentNo: this.yohiBeerData.equipmentNo,
        tenantGoodsId: this.yohiBeerData.tenantGoodsId,
        goodsScore: this.yohiBeerData.goodsScore,
        goodsName: this.yohiBeerData.goodsName
      })
        .then(() => {
          this.loading = false;
          this.exchangeType = 'yohi_beer';
          this.exchangeCallback();
        }).catch(() => {
        this.loading = false;
      });
    },
    exchangeCallback() {
      this.queryUserTickets();
      this.successCountSecond = 4 * 1000;
      this.step = 'exchange_success';
    },
    goMyPage() {
      this.$router.push('/about');
    },
    initMessageWatcher() {
      const vm = this;
      document.addEventListener('message', function (event) {
        vm.handleMessage(event);
      }, false);
      window.addEventListener('message', function (event) {
        vm.handleMessage(event);
      }, false);
      if (window.CagesScanner) {
        window.CagesScanner.addEventListener('message', function (event) {
          vm.handleMessage(event);
        }, false);
      }
    },
    handleMessage(event) {
      const result = event.data !== 'undefined' && typeof event.data === 'string' ?
        JSON.parse(event.data) : event.data;
      if (_.get(result, 'message') === 'scan_result') {
        this.scanResult = _.get(result, 'data.data');
        this.matchScanContentType();
      }
    }
  }
}
</script>

<style lang="scss">
.home {
  //background-image: url("../assets/images/main_bg.png");
  .bg-home{
    background-image:
        linear-gradient(to bottom, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.8) 100%),
        url("../assets/images/main_bg.png");
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 110%;
  }


  .headline {
    h1 {
      white-space: nowrap;
      width: 50%;
    }

    &.en {
      .img-line {
        position: relative;
        width: 20%;
        height: 15px;
        top: 5px;
      }
    }

    &.cn {
      .img-line {
        position: relative;
        width: 30%;
        height: 15px;
        top: 5px;
      }
    }
  }

  .btn-my-credit {
    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 28.8%;
      width: 5px;
      height: 20px;
      background: theme('colors.main');
    }
  }

  .dialog-self-help {
    overflow: visible !important;

    .bg-images {
      position: relative;

      .img-location {
        position: absolute;
        z-index: 9999;
        width: 50px;
        left: 61%;
        top: 9%;
      }
    }

    .img-close {
      position: absolute;
      bottom: -10%;
      left: 45%;
    }
  }

  .van-count-down {
    color: #fff !important;
  }

  .machine-list {
    .machine-poster {
      width: 90px;
      height: 95px;
    }
  }

  .dialog-scan {
    overflow: visible !important;

    .img-close {
      position: absolute;
      bottom: -10%;
      left: 45%;
    }

    .dialog-scan-logo {
      width: 100%;
    }

    .yohi-dialog-scan-logo {
      margin: 0 auto;
      width: 50%;
      max-width: 100%;
      max-height: 400px;
    }
  }

  .loading-indicator {
    font-weight: bold;
    font-size: 1rem;
    text-align: center;
  }

  .img-point {
    margin-top: -8px;
  }

  .top {
    height: 250px;
  }

  .icon-container {
    padding-top: 2px;
  }

  .border-rounded-10 {
    border-radius: 10px;
  }

  .title-credit {
    border-left: 5px solid theme('colors.main');
    padding-left: 10px;
  }

  .lucky-draw-banner {
    width: 100%;
    height: 80px;
    background: url("../assets/images/lottery/lucky_draw_banner.png") no-repeat;
    background-size: cover;
    padding: 10px;

    .logo {
      width: 60px;
      height: 60px;
      display: block;
    }

    .lucky-draw-banner-right {
      width: calc(100% - 100px);
    }

    .lh-14 {
      line-height: 14px;
    }

    .img-date {
      margin-bottom: 1px;
    }

    .lucky-draw-button {
      border-radius: 9px;
      display: block;
      line-height: 18px;
      height: 18px;
      margin-top: 4px;
    }

    .divide-gray-700 > :not(template) ~ :not(template) {
      border-color: #2c2c2c !important;
    }
  }

  .home-content {
    padding-bottom: 70px;
  }

  .home-footer {
    background-attachment: fixed;
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: #1B1C1E;
    .wechat-prompt {
      color: rgba(255, 255, 255, .6);
      text-align: center;
      line-height: 38px;
    }
  }
}

</style>
